<script setup lang="ts">
const props = defineProps<{
    details: Record<string, any>;
}>();
</script>

<template>
    <div class="gridClass flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-0 relative z-[1]">
        <div class="w-full lg:w-1/2 flex flex-col order-2 lg:order-1">
            <div class="w-full">
                <div class="relative">
                    <h1 class="lg:mt-3 -mb-2 lg:mb-5 text-start relative z-1">
                        <span class="block lg:inline text-center lg:text-start text-white">
                            {{ props.details.title }}
                        </span>
                    </h1>
                </div>
                <p class="text-white mt-4 lg:mt-2 text-center lg:text-justify w-full lg:w-[95%] text-body1-semibold">
                    {{ props.details.desc }}
                </p>
            </div>
            <div class="flex mt-10 lg:mb-1 flex-col lg:flex-row *:mb-4 *:lg:mb-0 *:lg:w-[45%] justify-between">
                <ProductButton :buttonInfo="props.details.firstButton" />
                <ProductButton :buttonInfo="props.details.secondButton" />
            </div>
        </div>
        <div class="w-full lg:w-[60%] flex justify-center items-start order-1 lg:order-2">
            <NuxtImg 
                src="/img/prefix-8.webp"
                alt="خط تلفن رند ابری پیش‌شماره ۸ تهران"
                width="800" 
                height="550"
                sizes="250px md:600px lg:800px"
                :preload="{ fetchPriority: 'high' }"
                loading="eager"
            />
        </div>
    </div>
</template>